<template>
	<div style="padding-top: 5px; padding-left: 10px; padding-right: 10px; padding-bottom: 15px; flex: 1; display: flex">
		<vue2-tinymce-editor :options="tinymceConfig" v-model="content" class="sa-tinymce"></vue2-tinymce-editor>
	</div>
</template>

<script>
import { Vue2TinymceEditor } from "vue2-tinymce-editor";
export default {
	components: { Vue2TinymceEditor },
	data() {
		return {
			content: "",
			tinymceConfig: {
				skin: "oxide",
				content_css: "default",
				icons: "default",
				// height: 500,
				menubar: true,
				branding: true,
				plugins: "lists table",
				toolbar: "undo redo | alignleft aligncenter alignright alignjustify | table | KBox | bold italic underline strikethrough forecolor backcolor | bullist numlist | removeformat",

				valid_elements: "b,i,u,br,p,ol,ul,li,font,sub,sup,strong,h1,span,em,h2,h3,div,table,thead,tbody,tfoot,tr,td,th,label,span[data-checked|class]",
				extended_valid_elements: "span[style|class|data-checked],div[style|class],p[style|class],em[style|class],strong[style|class],table[style|class],tr[style|class],td[style|class],th[style|class]",

				forced_root_block: "div",
				remove_trailing_brs: false,
				entity_encoding: "raw",

				content_style: `
    body { font-family: Arial, sans-serif; font-size: 14px; }
    .ft-checkbox-box { display: flex; margin: 10px 0; cursor: pointer; max-width:'max-content' }
    .ft-checkbox-box .ft-checkbox { display: inline-block; width: 15px; height: 15px; border: 2px solid #333; margin-right: 8px;  vertical-align: middle; background-color: #fff; }
    .ft-checkbox-box[data-checked="true"] .ft-checkbox { background-color: #007bff; }
  `,
				theme: "silver",
				setup(editor) {
					// Pulsante personalizzato Checklist
					editor.ui.registry.addButton("KBox", {
						text: "KBox",
						tooltip: "Inserisci una chechbox",
						onAction: () => {
							const boxHtml = `
                            <div class="ft-checkbox-box" data-checked="false">
                                <span class="ft-checkbox"></span>
                                <span class="ft-checkbox-label">text</span>
                            </div>
                            `;
							editor.insertContent(boxHtml);
						},
					});
					editor.on("click", function (e) {
						const box = e.target.closest(".ft-checkbox-box");
						if (!box) return;
						e.stopPropagation();
						const isLabelClick = e.target.classList.contains("ft-checkbox-label") || e.target.classList.contains("ft-checkbox");
						if (isLabelClick) {
							const checked = box.getAttribute("data-checked") === "true";
							box.setAttribute("data-checked", !checked);
						}
					});

					editor.on("dragover", function (e) {
						e.preventDefault();
						editor.focus();
					});
					editor.on("drop", function (e) {
						e.preventDefault();
						editor.focus();
						let data = e.dataTransfer.getData("text/html");
						if (data) {
							editor.insertContent(data);
							editor.nodeChanged();
							editor.focus();
							console.log(editor);
						}
					});
				},
			},
		};
	},
	watch: {
		content() {
			this.$emit("updateContent", this.content);
		},
	},
	methods: {
		setContent(textContent) {
			this.content = textContent;
		},
	},
};
</script>

<style></style>
